import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    loading: false,
    eventData: null,
    calender: null,
    error: null,
    response: null,
    handbook: null,
    calenderList: null
}

export const GetEventData = createAsyncThunk(
    "GetEventData",
    async (body) => {
        try {
            const response = await instance.get(`/crm/events/fetch-events${body}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    })

export const CreateEvent = createAsyncThunk(
    "CreateEvent",
    async (body) => {
        try {
            const response = await instance.post("/crm/events/create-events", body);
            return response?.data
        } catch (error) {
            return error
        }
    }
)



//UPLOAD-CALENDER-PDF-START

export const uploadCalenderPdf = createAsyncThunk(
    "uploadCalenderPdf",
    async (body) => {
        try {

            const response = await instance.post("/crm/events/upload-calender", body);
            return response?.data
        } catch (error) {
            return error
        }
    }
)
//UPLOAD-CALENDER-PDF-END

//VIEW-CALENDER-PDF-START

export const ViewUploadCalenderPdf = createAsyncThunk(
    "ViewUploadCalenderPdf",
    async () => {
        try {

            const response = await instance.get("/crm/events/view-calender");
            return response?.data
        } catch (error) {
            return error
        }
    }
)
//VIEW-CALENDER-PDF-END  



//UPLOAD-HRHANDBOOK-PDF-START

export const uploadHrHandBookPdf = createAsyncThunk(
    "uploadHrHandBookPdf",
    async (body) => {
        try {

            const response = await instance.post("/crm/events/upload-hrhandbook", body);
            return response?.data
        } catch (error) {
            return error
        }
    }
)
//UPLOAD-HRHANDBOOK-PDF-END


//VIEW-HRHANDBOOK-PDF-START

export const ViewHrHandBookPdf = createAsyncThunk(
    "ViewHrHandBookPdf",
    async () => {
        try {

            const response = await instance.get("/crm/events/view-hrhandbook");
            return response?.data
        } catch (error) {
            return error
        }
    }
)
//VIEW-HRHANDBOOK-PDF-END 

export const UpdateEvent = createAsyncThunk(
    "UpdateEvent",
    async (body) => {
        try {
            const response = await instance.post(`/crm/events/update-event?id=${body.id}`, body.evData);
            return response?.data
        } catch (error) {
            return error
        }
    }
)
export const RemoveEvent = createAsyncThunk(
    "RemoveEvent",
    async (id) => {
        try {
            const response = await instance.get(`/crm/events/remove-event?id=${id}`);
            return response?.data
        } catch (error) {
            return error
        }
    }
)


// {Visko Calender list }

export const fetchCalenderList = createAsyncThunk(
    "fetchCalenderList",
    async (body) => {
        try {

            const response = await instance.get(`/crm/calender/get-calender-row?page=${body.page}&search=${body.search}`);
            return response?.data
        } catch (error) {
            return error
        }
    }
)

export const removeHolidayList = createAsyncThunk(
    "removeHolidayList",
    async (id) => {

        try {
            const response = await instance.delete(`/crm/calender/delete-calender-row?id=${id}`);
            return response.data
        } catch (error) {

        }
    }
)

export const addHolidayList = createAsyncThunk(
    "addHolidayList",
    async (body) => {

        try {
            const res = await instance.post("/crm/calender/added-calender-row", body)
            return res?.data
        } catch (error) {
            throw error
        }
    }
)

export const updateHolidayList = createAsyncThunk(
    "updateHolidayList",
    async (data) => {

        try {


            const response = await instance.post(`/crm/calender/update-calender-row?id=${data.id}`, data?.data)
            return response?.data

        } catch (error) {
            throw error;
        }
    }
);




export const EventSlice = createSlice({
    name: "EventSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(GetEventData.pending, (state) => {
            state.response = null;
            state.loading = true;
        });
        builder.addCase(GetEventData.fulfilled, (state, action) => {
            state.loading = false;
            state.eventData = action.payload;
        });
        builder.addCase(GetEventData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(CreateEvent.pending, (state) => {
            state.response = null;
            state.loading = true;
        });
        builder.addCase(CreateEvent.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(CreateEvent.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(UpdateEvent.pending, (state) => {
            state.response = null;
            state.loading = true;
        });
        builder.addCase(UpdateEvent.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(UpdateEvent.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(RemoveEvent.pending, (state) => {
            state.response = null;
            state.loading = true;
        });
        builder.addCase(RemoveEvent.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(RemoveEvent.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })


        builder.addCase(uploadCalenderPdf.pending, (state) => {

            state.loading = true;
        });
        builder.addCase(uploadCalenderPdf.fulfilled, (state, action) => {
            state.loading = false;
        });
        builder.addCase(uploadCalenderPdf.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })
        builder.addCase(ViewUploadCalenderPdf.pending, (state) => {

            state.loading = true;
        });
        builder.addCase(ViewUploadCalenderPdf.fulfilled, (state, action) => {
            state.loading = false;
            state.calender = action.payload
        });
        builder.addCase(ViewUploadCalenderPdf.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })
        builder.addCase(ViewHrHandBookPdf.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(ViewHrHandBookPdf.fulfilled, (state, action) => {
            state.loading = false;
            state.handbook = action.payload
        });
        builder.addCase(ViewHrHandBookPdf.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(fetchCalenderList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchCalenderList.fulfilled, (state, action) => {

            state.loading = false;
            state.calenderList = action.payload?.data
        });
        builder.addCase(fetchCalenderList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(addHolidayList.pending, (state) => {
            state.response = null;
            state.loading = true;
        });
        builder.addCase(addHolidayList.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(addHolidayList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(updateHolidayList.pending, (state) => {
            state.response = null;
            state.loading = true;
        });
        builder.addCase(updateHolidayList.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(updateHolidayList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })

        builder.addCase(removeHolidayList.pending, (state) => {
            state.response = null;
            state.loading = true;
        });
        builder.addCase(removeHolidayList.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(removeHolidayList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error;
        })
    }

})

export default EventSlice.reducer;